// Footer.jsx

import React from 'react';
import './styles.css'; 
import './index.css'; 
import './App.css'; 
import facebookIcon from './images/facebook.png';
import x3Icon from './images/x3.png';
import instagramIcon from './images/instagram.png';
import patreonIcon from './images/patreon.png';
import tiktokIcon from './images/tiktok.png';
import linkedinIcon from './images/linkedin.png';
import youtubeIcon from './images/youtube.png';
import discordIcon from './images/discord.png';

const Footer = () => {

  const handleInteraction = (url) => (event) => {
    // Prevent default behavior to avoid blocking by Safari
    event.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="footer">
      <div className="social-icons">
        <a href="https://www.facebook.com/squada.io/" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.facebook.com/squada.io/')} onTouchEnd={handleInteraction('https://www.facebook.com/squada.io/')}>
          <img src={facebookIcon} alt="Facebook" className="social-icon" />
        </a>
        <a href="https://twitter.com/squada_io" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://twitter.com/squada_io')} onTouchEnd={handleInteraction('https://twitter.com/squada_io')}>
          <img src={x3Icon} alt="X" className="social-icon" /> 
        </a>
        <a href="https://www.instagram.com/squada.io/" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.instagram.com/squada.io/')} onTouchEnd={handleInteraction('https://www.instagram.com/squada.io/')}>
          <img src={instagramIcon} alt="Instagram" className="social-icon" />
        </a>
        <a href="https://www.tiktok.com/@squada_io" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.tiktok.com/@squada_io')} onTouchEnd={handleInteraction('https://www.tiktok.com/@squada_io')}>
          <img src={tiktokIcon} alt="Tiktok" className="social-icon" />
        </a>
        <a href="https://www.linkedin.com/company/squada-io/" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.linkedin.com/company/squada-io/')} onTouchEnd={handleInteraction('https://www.linkedin.com/company/squada-io/')}>
          <img src={linkedinIcon} alt="Linkedin" className="social-icon" />
        </a>
        <a href="https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA')} onTouchEnd={handleInteraction('https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA')}>
          <img src={youtubeIcon} alt="Youtube" className="social-icon" />
        </a>
        <a href="https://www.patreon.com/SQUADA" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.patreon.com/SQUADA')} onTouchEnd={handleInteraction('https://www.patreon.com/SQUADA')}>
          <img src={patreonIcon} alt="Patreon" className="social-icon" />
        </a>
        <a href="https://discord.gg/CRZW7u7b7K" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://discord.gg/CRZW7u7b7K')} onTouchEnd={handleInteraction('https://discord.gg/CRZW7u7b7K')}>
          <img src={discordIcon} alt="Discord" className="social-icon" />
        </a>
      </div>

      <p className="email">davidbarbedillo@gmail.com</p>
      <p className="copyright">©2026 David Barbedillo | All rights reserved</p>
    </footer>
  );
};

export default Footer;













// // Footer.jsx (Works on Mobile Chrome but not safari)

// import React from 'react';
// import './styles.css'; 
// import './index.css'; 
// import './App.css'; 
// import facebookIcon from './images/facebook.png';
// import x3Icon from './images/x3.png';
// import instagramIcon from './images/instagram.png';
// import patreonIcon from './images/patreon.png';
// import tiktokIcon from './images/tiktok.png';
// import linkedinIcon from './images/linkedin.png';
// import youtubeIcon from './images/youtube.png';
// import discordIcon from './images/discord.png';

// const Footer = () => {

//   const handleInteraction = (url) => (event) => {
//     // Open the URL directly
//     window.open(url, '_blank', 'noopener,noreferrer');
//   };

//   return (
//     <footer className="footer">
//       <div className="social-icons">
//         <a href="https://www.facebook.com/squada.io/" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.facebook.com/squada.io/')} onTouchStart={handleInteraction('https://www.facebook.com/squada.io/')}>
//           <img src={facebookIcon} alt="Facebook" className="social-icon" />
//         </a>
//         <a href="https://twitter.com/squada_io" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://twitter.com/squada_io')} onTouchStart={handleInteraction('https://twitter.com/squada_io')}>
//           <img src={x3Icon} alt="X" className="social-icon" /> 
//         </a>
//         <a href="https://www.instagram.com/squada.io/" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.instagram.com/squada.io/')} onTouchStart={handleInteraction('https://www.instagram.com/squada.io/')}>
//           <img src={instagramIcon} alt="Instagram" className="social-icon" />
//         </a>
//         <a href="https://www.tiktok.com/@squada_io" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.tiktok.com/@squada_io')} onTouchStart={handleInteraction('https://www.tiktok.com/@squada_io')}>
//           <img src={tiktokIcon} alt="Tiktok" className="social-icon" />
//         </a>
//         <a href="https://www.linkedin.com/company/squada-io/" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.linkedin.com/company/squada-io/')} onTouchStart={handleInteraction('https://www.linkedin.com/company/squada-io/')}>
//           <img src={linkedinIcon} alt="Linkedin" className="social-icon" />
//         </a>
//         <a href="https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA')} onTouchStart={handleInteraction('https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA')}>
//           <img src={youtubeIcon} alt="Youtube" className="social-icon" />
//         </a>
//         <a href="https://www.patreon.com/SQUADA" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://www.patreon.com/SQUADA')} onTouchStart={handleInteraction('https://www.patreon.com/SQUADA')}>
//           <img src={patreonIcon} alt="Patreon" className="social-icon" />
//         </a>
//         <a href="https://discord.gg/CRZW7u7b7K" target="_blank" rel="noopener noreferrer" onClick={handleInteraction('https://discord.gg/CRZW7u7b7K')} onTouchStart={handleInteraction('https://discord.gg/CRZW7u7b7K')}>
//           <img src={discordIcon} alt="Discord" className="social-icon" />
//         </a>
//       </div>

//       <p className="email">info@squada.io</p>
//       <p className="copyright">©2024 SQUADA | All rights reserved</p>
//     </footer>
//   );
// };

// export default Footer;


























// // Footer.jsx

// import React from 'react';
// import './styles.css'; 
// import './index.css'; 
// import './App.css'; 
// import facebookIcon from './images/facebook.png';
// import x3Icon from './images/x3.png';
// import instagramIcon from './images/instagram.png';
// import patreonIcon from './images/patreon.png';
// import tiktokIcon from './images/tiktok.png';
// import linkedinIcon from './images/linkedin.png';
// import youtubeIcon from './images/youtube.png';
// import discordIcon from './images/discord.png';

// const Footer = () => {

//   const handleTouchStart = (url) => (event) => {
//     if (event.type === 'touchstart') {
//       window.open(url, '_blank', 'noopener,noreferrer');
//     }
//   };

//   return (
//     <footer className="footer">
//       <div className="social-icons">
//         <a href="https://www.facebook.com/squada.io/" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://www.facebook.com/squada.io/')}>
//           <img src={facebookIcon} alt="Facebook" className="social-icon" />
//         </a>
//         <a href="https://twitter.com/squada_io" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://twitter.com/squada_io')}>
//           <img src={x3Icon} alt="X" className="social-icon" /> 
//         </a>
//         <a href="https://www.instagram.com/squada.io/" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://www.instagram.com/squada.io/')}>
//           <img src={instagramIcon} alt="Instagram" className="social-icon" />
//         </a>
//         <a href="https://www.tiktok.com/@squada_io" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://www.tiktok.com/@squada_io')}>
//           <img src={tiktokIcon} alt="Tiktok" className="social-icon" />
//         </a>
//         <a href="https://www.linkedin.com/company/squada-io/" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://www.linkedin.com/company/squada-io/')}>
//           <img src={linkedinIcon} alt="Linkedin" className="social-icon" />
//         </a>
//         <a href="https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA')}>
//           <img src={youtubeIcon} alt="Youtube" className="social-icon" />
//         </a>
//         <a href="https://www.patreon.com/SQUADA" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://www.patreon.com/SQUADA')}>
//           <img src={patreonIcon} alt="Patreon" className="social-icon" />
//         </a>
//         <a href="https://discord.gg/CRZW7u7b7K" target="_blank" rel="noopener noreferrer" onTouchStart={handleTouchStart('https://discord.gg/CRZW7u7b7K')}>
//           <img src={discordIcon} alt="Discord" className="social-icon" />
//         </a>
//       </div>

//       <p className="email">info@squada.io</p>
//       <p className="copyright">©2024 SQUADA | All rights reserved</p>
//     </footer>
//   );
// };

// export default Footer;














// // Footer.jsx

// import React from 'react';
// import './styles.css'; 
// import './index.css'; 
// import './App.css'; 
// // import { NavLink } from 'react-router-dom';
// import facebookIcon from './images/facebook.png';
// import x3Icon from './images/x3.png';
// import instagramIcon from './images/instagram.png';
// import patreonIcon from './images/patreon.png';
// import tiktokIcon from './images/tiktok.png';
// import linkedinIcon from './images/linkedin.png';
// import youtubeIcon from './images/youtube.png';
// import discordIcon from './images/discord.png';





// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="social-icons">
        
//         <a href="https://www.facebook.com/squada.io/" target="_blank" rel="noopener noreferrer">
//           <img src={facebookIcon} alt="Facebook" className="social-icon" />
//         </a>
//         <a href="https://twitter.com/squada_io" target="_blank" rel="noopener noreferrer">
//           <img src={x3Icon} alt="X" className="social-icon" /> 
//         </a>
//         <a href="https://www.instagram.com/squada.io/" target="_blank" rel="noopener noreferrer">
//           <img src={instagramIcon} alt="Instagram" className="social-icon" />
//         </a>
//         <a href="https://www.tiktok.com/@squada_io" target="_blank" rel="noopener noreferrer">
//           <img src={tiktokIcon} alt="Tiktok" className="social-icon" />
//         </a>
//         <a href="https://www.linkedin.com/company/squada-io/" target="_blank" rel="noopener noreferrer">
//           <img src={linkedinIcon} alt="Linkedin" className="social-icon" />
//         </a>
//         <a href="https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA" target="_blank" rel="noopener noreferrer">
//           <img src={youtubeIcon} alt="Youtube" className="social-icon" />
//         </a>
//         <a href="https://www.patreon.com/SQUADA" target="_blank" rel="noopener noreferrer">
//           <img src={patreonIcon} alt="Patreon" className="social-icon" />
//         </a>
//         <a href="https://discord.gg/CRZW7u7b7K" target="_blank" rel="noopener noreferrer">
//           <img src={discordIcon} alt="Discord" className="social-icon" />
//         </a>
//       </div>

//       <p className="email">info@squada.io</p>
//       <p className="copyright">©2024 SQUADA | All rights reserved</p>
//     </footer>
//   );
// };

// export default Footer;